export const WSS_BASE_URL = 'wss://api.ohaio.io/api/v1/translate/google/ws'
export const QR_URL = 'https://speaker.ohaio.io'
export const OHAIO_API_URL = 'https://api.ohaio.io/api'
